<script lang="ts" setup>
import type { IAppProps } from '@/interfaces/IAppProps'
import { LazyIcon } from '@sbo/icons-vue'
import { toRefs } from 'vue'
import { useEntryProps } from '@/composable/useDatasetProps'
import { useGlobalStore } from '@/stores/globalStore'
import { isMobile } from '@/utils/shared'

const { homeUrl, brandName } = useEntryProps<IAppProps>()
const globalStore = useGlobalStore()
const { goBack } = toRefs(globalStore)
</script>

<template>
    <div v-if="isMobile()" class="brand-logo-mobile">
        <LazyIcon
            name="system:arrowLeft"
            color="white"
            height="32"
            width="32"
            data-gtm-category="Common"
            data-gtm-label="Common_Header_Back_Btn"
            @click="goBack(homeUrl)"
        />
        <div data-gtm-category="Common" data-gtm-label="Common_Header_Brand_logo_Btn" @click="goBack(homeUrl)">
            <img
                v-if="brandName === 'SBOBET'"
                alt="SBOBET"
                src="../../assets/images/logo_sbobet.svg"
            >
            <img v-else alt="SBOTOP" src="../../assets/images/logo_sbotop.svg">
        </div>
    </div>
    <div v-else class="brand-logo" data-gtm-category="Common" data-gtm-label="Common_Header_Brand_logo_Btn">
        <img
            v-if="brandName === 'SBOBET'"
            alt="SBOBET"
            src="../../assets/images/logo_sbobet.svg"
            @click="goBack(homeUrl)"
        >
        <img v-else alt="SBOTOP" src="../../assets/images/logo_sbotop.svg" @click="goBack(homeUrl)">
    </div>
</template>
